import React from 'react';
import styled from 'styled-components'
import GetGlobalStyle from './JS-CSS/Global';
import {Link} from 'react-router-dom'

// const BARANIMATE = keyframes`
// 0% {
//     opacity: .6;
//     width: 0%;
//     transition: 1s;

// }

// 25% {
//     opacity: .7;
//     width: 21.25%;
//     transition: 1s;

// }

// 50% {
//     opacity: .8;
//     width: 42.25%;
//     transition: 1s;

// }

// 75% {
//     opacity: .9;
//     width: 63.75%;
//     transition: 1s;

// }

// 100% {
//     opacity: 1
//     width: 85%;
//     transition: 1s;


// }
// `

const SIDEBAR = styled.nav`
@media screen and (min-width: 48rem) {
    display: none;
}
    z-index: 50;
 transition: 1s;
overflow: scroll;
display: flex;
flex-direction: column;
background: rgba(38, 20, 49, 0.97);
    position: fixed;
    right: 0;
    height: 100vh;
    top: 0;
    width: ${props => props.showMe === "showMe" ? '85%' : '0%'};
    transition: .5s;
    opacity: ${props => props.showMe === "showMe" ? '1' : '.5'};

    & h4 {
        margin-top: 1.2rem;
   width: 311px;
    padding-left: 1rem;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 20px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-transform: capitalize;
    color: #BFB4B4;

    }

    & ul {
        width: 139px;
        height: 200px;
        list-style-type: none;
        margin-left: calc(110% - 18.5rem);
        
        @media screen and (width: 48rem) {
            
            margin-left: calc(110% - 40.5rem);
        }
 
        & li {
            margin-top: 2rem;
            width: 10rem;

            img.iAva {
                width: 30px;
                height: 30px;
                border-radius: 50%;
            }
        }
        & li a {
            text-decoration: none;
            vertical-align: super;
            color: white;
            margin-left: .5rem;
                }
    }

    & p {
        margin-top: 5rem;
        background: white;
        padding: calc(26px - 1rem);
        font-size: 18px;
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
    }
 
`

const SideBar = ({userName, avatar, showMe}) => {
    return (

        <>
   
 <SIDEBAR 
 showMe={showMe}
  >
     
        <GetGlobalStyle 
        hei={'100%'}
        overF={`${showMe === "showMe" ? "hidden" : "scroll"}`} 
        /> 

{/* <h4>Good morning {`${typeof(userName) === "string" ? ', ' + userName : ''}`} </h4> */}

 
<ul>
    <li>
        <img alt="icon" src={`${require('../Assets/Images/mySvgOne.svg')}`} /> <Link to="/iamwealthy-login">Log in</Link> 
    </li>
    <li>
        <img alt="icon" src={`${require('../Assets/Images/mySvg.svg')}`} /> <Link to="/about">About</Link> 
    </li>
     
    <li>
        <span style={{color: 'white', verticalAlign: 'super'}}><Link to="/faqs">FAQ's</Link></span>
        {/* <img 
        alt="icon" 
        src={`${require('../Assets/Images/mySvgTwo.svg')}`} />  */}
    </li>
    <li>
        <span style={{color: 'white', verticalAlign: 'super'}}><Link to="/dashboard">Dashboard</Link></span>
        {/* <img 
        alt="icon" 
        src={`${require('../Assets/Images/mySvgTwo.svg')}`} />  */}
    </li>

</ul>

<p>Welcome, to the home of wealth</p>

<hr style={{width: '90%', marginTop: '6rem'}} />
<section>
    <ul>
    <li>
        <img alt="icon" src={`${require('../Assets/Images/mySvgThree.svg')}`} /> <Link to="/dashboard">Help center</Link> 
    </li>
    {/* <li>
        <img alt="icon" src={`${require('../Assets/Images/mySvgFoursvg.svg')}`} /> <a href="/home">Settings</a> 
    </li>
    <li>
        <img 
        alt="icon" 
        src={avatar}
        className="iAva" /> 
    </li> */}
        </ul>



</section>


</SIDEBAR>
        </>

      );
}

SideBar.defaultProps = {
    userName : 'Armstrong',
    avatar: require('../Assets/Images/felaWealth.jpg'),
    showMe: null
}
 
export default SideBar;